/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Aui 의 버전을 정의한다.
 *
 * @file /src/base/Aui.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 6. 8.
 */
export const VERSION = '5.0.254';
